import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsJobType, PmsJobType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsJobType>
    useData={usePmsJobType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
